export default __webpack_public_path__ + "static/media/goopter-use-case-restaurant.457eb396.jpg";